module.exports = __webpack_public_path__ + "images/empty-states/mbtv-empty-state-board-placeholder.fe9e6cf490d7fff37282.svg";